(() => {
  'use strict';
  // Liquid supplies the first image ratio. Loaded dimensions also cover variant
  // swaps and responsive <picture> sources without guessing a crop or shape.
  const update = image => {
    if (!(image instanceof HTMLImageElement)) return;
    const frame = image.closest('[data-native-image-ratio]');
    if (!frame || !image.naturalWidth || !image.naturalHeight) return;
    if (frame.matches('[data-gallery-frame], .np-quick-order__image') && frame.style.getPropertyValue('--np-image-native-ratio')) return;
    const ratio = image.naturalWidth / image.naturalHeight;
    if (Number.isFinite(ratio) && ratio > 0) frame.style.setProperty('--np-image-native-ratio', String(ratio));
  };
  const scan = root => root.querySelectorAll('[data-native-image-ratio] img').forEach(update);
  document.addEventListener('load', event => update(event.target), true);
  document.addEventListener('shopify:section:load', event => scan(event.target));
  document.addEventListener('nirala:quick-order-mounted', event => scan(event.target instanceof Element ? event.target : document));
  scan(document);
})();
